const versionInfo = {
    version: 2.5
}
    
export default versionInfo